import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { Axios } from "../../../Api/axios";
import { ADMIN_ALL_CLASSES, ADMIN_UPDATE_CLASS } from "../../../Api/Api";
import LoadingSubmit from "../../../Components/Loading/Loading";
import { useNavigate, useParams } from "react-router-dom";
import DashDialog from "../../../Components/Dashboard/DashDialog";

export default function EditClass() {
  const { id }              = useParams();
  const [name, setName]     = useState("");
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const focus = useRef(null);
  const nav   = useNavigate();

  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES)
      .then((res) => {
        const list = res.data.classes || res.data || [];
        const found = list.find((c) => String(c.id) === String(id));
        if (found) setName(found.name || "");
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setFetching(false);
        focus.current?.focus();
      });
  }, [id]);

  async function handleSubmit() {
    if (!name.trim()) return;
    setLoading(true);
    try {
      await Axios.put(ADMIN_UPDATE_CLASS(id), { name: name.trim() });
      nav("/dashboard/classes");
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  return (
    <>
      {loading && <LoadingSubmit />}
      <DashDialog
        title="تعديل الصف الدراسي"
        onSubmit={handleSubmit}
        submitDisabled={name.trim().length < 2 || loading || fetching}
        submitLabel={loading ? "جاري الحفظ..." : "حفظ التعديلات"}
      >
        <Form.Group className="mb-4" controlId="className">
          <Form.Label>اسم الصف</Form.Label>
          <Form.Control
            ref={focus}
            value={fetching ? "" : name}
            required
            onChange={(e) => setName(e.target.value)}
            type="text"
            placeholder={fetching ? "جاري التحميل..." : "مثال: الصف العاشر..."}
            disabled={fetching}
          />
        </Form.Group>
      </DashDialog>
    </>
  );
}
